import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './components';
import './style/index.css';

ReactDOM.render(<App />, document.getElementById('root'));
